import { CustomPriceList } from '../../../../../../domain/Account';
import * as R from 'ramda';

export const findCustomPriceListIndexFromGivenId =
  (id: string) =>
  (customPriceLists: CustomPriceList[]): number =>
    R.findIndex((cPL) => cPL.id === id, customPriceLists);
